import React, { createContext, useContext, useState, useEffect, useRef } from 'react';
import axios from 'axios';
import API from '../../config';

const CurrentUserContext = createContext();

export const CurrentUserProvider = ({ children }) => {
    const [currentUser, setCurrentUser] = useState(null);
    const [isAuthenticated, setIsAuthenticated] = useState(null);
    const [isBlocked, setIsBlocked] = useState(false);
    const [isVerified, setIsVerified] = useState(false);
    const [loading, setLoading] = useState(true);
    const hasFetched = useRef(false);

    useEffect(() => {
        if (hasFetched.current) return;
        hasFetched.current = true;
    
        const token = localStorage.getItem('token');
        const storedVerified = localStorage.getItem('isVerified') === 'true';
    
        if (token && isAuthenticated === null) {
            setIsAuthenticated(true);
            setIsVerified(storedVerified);
        }
    
        const fetchCurrentUser = async (retries = 5, delay = 2000) => {
            if (!token) {
                setIsAuthenticated(false);
                setLoading(false);
                return;
            }
    
            for (let attempt = 0; attempt < retries; attempt++) {
                try {
                    const response = await axios.get(`${API}/users/me`, {
                        headers: { Authorization: `Bearer ${token}` },
                    });
    
                    setCurrentUser(response.data);
                    setIsAuthenticated(true);
                    setIsVerified(response.data.is_verified);
                    setIsBlocked(!response.data.is_active);
                    localStorage.setItem('isVerified', response.data.is_verified);
                    setLoading(false);
                    return;
                } catch (error) {
                    if (error.response?.status === 401) { 
                        // Если токен недействителен, разлогиниваю пользователя
                        localStorage.removeItem('token');
                        localStorage.removeItem('isVerified');
                        setIsAuthenticated(false);
                        setCurrentUser(null);
                        setLoading(false);
                        window.location.href = '/sign-in';
                        return;
                    }
    
                    if (attempt < retries - 1) {
                        await new Promise((resolve) => setTimeout(resolve, delay));
                        continue;
                    }
    
                    setLoading(false);
                }
            }
        };
    
        fetchCurrentUser();
    
        const interval = setInterval(() => {
            fetchCurrentUser(1);
        }, 5 * 60 * 2000);
    
        return () => clearInterval(interval);
    }, [isAuthenticated]);

    return (
        <CurrentUserContext.Provider
            value={{ currentUser, isAuthenticated, isBlocked, isVerified, loading, setCurrentUser }}
        >
            {children}
        </CurrentUserContext.Provider>
    );
};

export const useCurrentUser = () => {
    return useContext(CurrentUserContext);
};